import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ARMarkerProps {
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.XRTrackable) public trackable?: Types["XRTrackable"];
  @Inlet(Accepts.XRRenderable) public renderable?: Types["XRRenderable"];

  @Inlet(Accepts.Subtitles) public subtitles?: Types["Subtitles"];

  @Inlet(Accepts.Image) public permissionMedia?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public permissionText?: Types["MarkdownText"];

  @Inlet(Accepts.Hints) public hints?: Types["Hints"];

  /**
   * Alternative image that is used when ARMarker is in degradation mode.
   * This should ideally be the first frame of the renderable media.
   */
  @Inlet(Accepts.Image) public degradedTrackable?: Types["Image"];
}

export const ARMarkerDefinition = defineElement("ar-marker", ARMarkerProps, {
  versionRequired: "0.13.0",
});
